import {wrap} from '../../shared/loading-overlay'
;(function module() {
  angular.module('app.ui.form.ctrls').controller('WelcomeModalController', [
    'candidate',
    'SharedApi',
    '$scope',
    '$rootScope',
    'logger',
    'CandidateProfileApi',
    '$uibModalInstance',
    function controller(
      candidate,
      SharedApi,
      $scope,
      $rootScope,
      logger,
      CandidateProfileApi,
      $uibModalInstance
    ) {
      let vm = this
      vm.contractsFilterData = []
      vm.occupationsFilterData = []
      vm.employerTypeFilterData = []
      vm.getAllPreferences = async () => {
        const {data: contracts} = await SharedApi.getAllContractTypes()

        contracts.forEach(contract => {
          vm.contractsFilterData.push({
            id: contract.id,
            name: contract.name,
            ticked: candidate.preferredContractTypes.some(
              ({id}) => id === contract.id
            ),
            value: contract.id,
          })
        })
        const {data: occupations} = await SharedApi.getAllOccupations()

        occupations.forEach(occupation => {
          vm.occupationsFilterData.push({
            id: occupation.id,
            name: occupation.name,
            ticked: candidate.occupations.some(({id}) => id === occupation.id),
            value: occupation.id,
          })
        })

        const {data: employerTypes} = await SharedApi.getCategoryById(2)
        employerTypes.specialties.forEach(employerType => {
          vm.employerTypeFilterData.push({
            id: employerType.id,
            name: employerType.name,
            ticked: candidate.category
              .find(({id}) => id === 2)
              .specialties.some(({id}) => id === employerType.id),
            value: employerType.id,
          })
        })

        $scope.$apply()
      }

      vm.validatePreferences = () => {
        let isPreferenceValid = true
        let isPreferenceInValid = true

        vm.employerTypeFilterData.forEach(employerType => {
          if (employerType.ticked) {
            isPreferenceInValid = false
          }
        })

        if (isPreferenceInValid) {
          isPreferenceValid = false
          logger.notify(
            'error',
            'At least one employer preference should be selected.'
          )
        }

        isPreferenceInValid = true
        vm.contractsFilterData.forEach(contract => {
          if (contract.ticked) {
            isPreferenceInValid = false
          }
        })

        if (isPreferenceInValid) {
          isPreferenceValid = false
          logger.notify(
            'error',
            'At least one contract preference should be selected.'
          )
        }

        isPreferenceInValid = true
        vm.occupationsFilterData.forEach(occupation => {
          if (occupation.ticked) {
            isPreferenceInValid = false
          }
        })

        if (isPreferenceInValid) {
          isPreferenceValid = false
          logger.notify(
            'error',
            'At least one occupation preference should be selected.'
          )
        }

        return isPreferenceValid
      }

      vm.updateCandidatePreference = async () => {
        if (vm.validatePreferences()) {
          try {
            const doUpdate = async () => {
              const preferences = {
                candidatePreference: {
                  preferredContractTypes: vm.contractsFilterData
                    .filter(contract => contract.ticked)
                    .map(({id}) => id),
                  occupations: vm.occupationsFilterData
                    .filter(occupation => occupation.ticked)
                    .map(({id}) => id),
                  specialtiesByCategory: [
                    {
                      id: 2,
                      specialties: vm.employerTypeFilterData
                        .filter(employerType => employerType.ticked)
                        .map(({id}) => id),
                    },
                  ],
                },
              }

              console.log(
                'Welcome Modal: candidate preferences are:',
                preferences
              )

              await CandidateProfileApi.updateProfileData(
                candidate.user.id,
                preferences
              )

              await CandidateProfileApi.updateUserSettings(
                candidate.user.id,
                1,
                false
              )

              $rootScope.$broadcast('candidate:wizard:completed')

              logger.notify(
                'success',
                'Preference updated successfully. Welcome to LexStep.'
              )
            }

            await wrap(async () => doUpdate())
          } catch (error) {
            logger.notify('error', `Failed to Update Preference`)
            if (error) {
              console.error('welcome wizard error:', error)
            }
          }

          $uibModalInstance.close()
        }
      }

      vm.getAllPreferences()
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/matches/welcome-modal-popup/welcome-modal.ctrl.js